module.exports = "<p>\n  paramatruntime works!\n</p>\n"